

















import { Component, Vue } from 'vue-property-decorator'
import { indexPageList } from '@/api/tenant/dataPage'
import TsTable from '@/components/TsTable/TsTable.vue'
import Edit from './components/edit.vue'
import { TableHead } from '@/types/common/tableComponent'
@Component({
  components: {
    TsTable,
    Edit
  }
})
export default class DataExplain extends Vue {
  dialogSlotShow = false
   tableData = {
     data: [],
     currentPage: 0,
     pageSize: 20,
     total: 0
   };

    tableTitleObj = {
      title: '数据说明维护',
      options: {
        dropdown: false,
        arr: [
          // {
          //   type: 'add',
          //   name: '新增'
          // }
        ]
      }
    };

    tableHead = [
      {
        // type: 'first',
        propName: 'name',
        labelName: '数据名称',
        options: {
          type: 'search'
        }
      },
      {
        propName: 'rootType',
        labelName: '数据类型',
        options: {
          type: 'search'
        }
      },
      {
        propName: 'updateDate',
        labelName: '数据更新日',
        options: {
          type: 'sort',
          optionArr: [
            {
              type: 'asc',
              name: '升序',
              icon: 'el-icon-top'
            },
            {
              type: 'desc',
              name: '降序',
              icon: 'el-icon-bottom'
            }
          ]
        }
      },
      {
        type: 'edit',
        labelName: '编辑',
        propName: 'edit',
        options: {
          dropdown: false,
          arr: [
            {
              type: 'edit',
              name: '修改',
              btnType: 'text'
            }
          ]
        }
      }
    ];

    tableSelectOpt = [
      {
        type: 'error',
        name: '批量删除',
        icon: 'el-icon-delete',
        color: 'red'
      },
      {
        type: 'info',
        name: '信息',
        icon: 'el-icon-info',
        color: 'blue'
      }
    ];

    created () {
      this.getIndexPageList()
    }

    async getIndexPageList (_form = {}) {
      const { tableData } = this
      const { currentPage, pageSize } = tableData
      const form = {
        page: currentPage,
        size: pageSize,
        ..._form
      }
      const { data } = await indexPageList(form)
      this.tableData.data = data.content
      this.tableData.total = data.totalElements
    }

    /**
   *   点击下拉或者按钮按钮触发
   *    type 按钮类型
   *    tableItem 如果按钮存在表格中 tableItem就是当前项
   */
    handleTableBtn (type: string, tableItem: TableHead) {
      (this.$refs.editRef as any).show(tableItem)
    }

    /**
   * handleFilter 过滤处理filter
   */
    handleFilter (tags: TableHead[]) {
      const form: {
        [propName: string]: string;
      } = {}
      tags.forEach((item: TableHead) => {
        switch (item.params.head.options.type) {
          case 'search':
            form[item.type] = item.params.opt.value
            break

          case 'sort':
            form.sortField = item.type
            form.direction = item.params.opt.type
            break
        }
      })
      this.getIndexPageList(form)
    }

    // 分页相关
    // 选择条数
    handleSizeChange (val: number) {
      this.tableData.pageSize = val
      this.getIndexPageList()
    }

    // 当前第几页
    handleCurrentChange (val: number) {
      this.tableData.currentPage = val
      this.getIndexPageList()
    }
}
